module.exports = __webpack_public_path__ + "img/product-smoke-11.1f29ddb2.jpg";